module.exports = __webpack_public_path__ + "static/2_3_game-tree-3-05047154d1da3d87d5d3c330812463a3.svg";